import { useCallback, useState } from 'react';

export function useRotateBoard() {
  const [rotated, setRotated] = useState<boolean | null>(null);

  const remapColor = useCallback(
    (orig: 'black' | 'white') => rotateColor(orig, rotated),
    [rotated],
  );

  const invertColor = useCallback((orig: 'black' | 'white') => rotateColor(orig, true), []);

  return {
    setRotated,
    rotated,
    remapColor,
    invertColor,
  };
}

function rotateColor(orig: 'black' | 'white', rotate?: boolean | null): 'black' | 'white' {
  return rotate ? (orig === 'black' ? 'white' : 'black') : orig;
}
